import Request from './request';

/**
 * 使用组件通用请求
 * @param {string} service 服务名称
 * @return {Request}
 */
export function useCommonApi(service) {
    const request = new Request();
    const commonApiRequest = request.bindCommonApi(service);

    return commonApiRequest;
}
